import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
// 测试
import VConsole from 'vconsole';

import Vant from 'vant';
import 'vant/lib/index.css';
import { Toast,Picker,CountDown,Progress,Area,Icon } from 'vant'
Vue.use(Vant);

Vue.use(Toast)
Vue.prototype.$axios = axios
Vue.config.productionTip = false;
Vue.prototype.$isTest = '2' // '1' 为测试环境 2生产

// Vue.prototype.$requestUrl = 'https://hsb-wine-sale.iyunfish.com'       //测试环境
// Vue.prototype.$downloadH5Url = 'https://hsb-wine-sale.iyunfish.com'    //测试环境
// const vConsole = new VConsole();

Vue.prototype.$requestUrl = 'https://wkd.fnhl.net'                     //正式环境
Vue.prototype.$downloadH5Url = 'https://wkd-download.fnhl.net'         //正式环境

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
